import { render, staticRenderFns } from "./ResponsiveCertificateFrame.vue?vue&type=template&id=0704cbfc&scoped=true&"
import script from "./ResponsiveCertificateFrame.vue?vue&type=script&lang=js&"
export * from "./ResponsiveCertificateFrame.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveCertificateFrame.vue?vue&type=style&index=0&id=0704cbfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704cbfc",
  null
  
)

export default component.exports